<template>
    <div class="media-type">
      <div class="media-type__button">
        <a
            class="media-type__clear"
            @click="clearSelected"
        ><span class="icon icon--cross"></span>{{ productStore.translations?.clear }}</a>
      </div>
      <label class="media-type__label">
        {{ productStore.translations?.mediatype }}
      </label>
      <div class="media-type__container">
        <section v-for="item in mediatypeitems">
          
          <div class="media-type__item">
            <a
                class="media-type__type"
                :class="item.name"
                @click="setActiveType(item, item.id)"

            ><span
                class="media-type__type--border-top"
                :class="{ active: item.isActive }"
            ></span>
              <span
                  class="media-type__icon item-icon"
                  :class="[item.icon, { active: item.isActive }]"
              ></span>
            </a>
            <div class="media-type__text">{{ item.translatedText }}</div>
          </div>
        </section>
      </div>
    </div>
</template>

<script setup>
import {ref} from 'vue';
import {useProductStore} from '../store/store';

const productStore = useProductStore();

const setActiveType = (type, typeId) => {
  productStore.selectedType = type.searchTerm;

  mediatypeitems.value.forEach(item => {
    item.isActive = item.id === typeId;
  });
}

function clearSelected() {
  productStore.clearFilter();
  mediatypeitems.value.forEach(item => {
    item.isActive = true;
  });
}

const mediatypeitems = ref([
  {
    id: 1,
    name: "brochures",
    searchTerm: "Machine Brochures",
    icon: "icon icon--brochure",
    text: "Brochures",
    translatedText: productStore.translations?.brochures,
    isActive: true,
  },
  {
    id: 2,
    name: "instructions",
    searchTerm: "Instructionbook",
    icon: "icon icon--instructions",
    text: "Instructions",
    translatedText: productStore.translations?.instructions,
    isActive: true,
  },
  {
    id: 3,
    name: "spare-parts",
    searchTerm: "SparePart Book",
    icon: "icon icon--spare-parts",
    text: "Spare Part Book",
    translatedText: productStore.translations?.sparePartBook,
    isActive: true,
  },
  {
    id: 4,
    name: "quick-start-machine",
    searchTerm: "Quick Start Instruction",
    icon: "icon icon--quick-start-machine",
    text: "Quick Start Machine",
    translatedText: productStore.translations?.quickStartMachine,
    isActive: true,
  },
  {
    id: 5,
    name: "fai",
    searchTerm: "Final Assembly Instruction",
    icon: "icon icon--fai",
    text: "FAI",
    translatedText: productStore.translations?.fai,
    isActive: true,
  },
]);
</script>